
export const readAppointmentResponseBody = async (response: Response): Promise<unknown> => {
  const text = await response.text();
  if (!text) {
    return '';
  }

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

export const formatAppointmentResponseBody = (body: unknown) =>
  typeof body === 'string' ? body : JSON.stringify(body) ?? String(body);

export const isSuccessfulAppointmentResponse = (response: Response, body: unknown) =>
  response.ok && response.status === 200 && typeof body === 'string' && body.startsWith('ok');
